type AuthSessionFailureHandler = () => void

let handler: AuthSessionFailureHandler | null = null

/** Called from `httpClient` on 401 for authenticated requests; bridge registers the real handler. */
export function setAuthSessionFailureHandler(next: AuthSessionFailureHandler | null): void {
  handler = next
}

export function notifyAuthSessionInvalid(): void {
  try {
    handler?.()
  } catch {
    // Avoid breaking fetch error paths if a handler throws.
  }
}
